/**
 * Custom JavaScript for Squijig Theme
 * Add all your custom code here to keep it separate from theme updates
 */

(function() {
  'use strict';
  console.log('Developed by!: heyjak: https://heyjak.com');

  // anncouncement bar
  if (!customElements.get('announcement-bar-component')){
    customElements.define(
      'announcement-bar-component',
      class AnnouncementBar extends HTMLElement {
        constructor() {
          super();
          this.currentIndex = 0;
          this.interval = null;
        }

        connectedCallback() {
          this.slides = this.querySelectorAll('span'); // Your announcement spans
          this.autoplaySpeed = 5000; // 5 seconds
          
          // Pause on hover
          this.addEventListener('mouseenter', () => this.pause());
          this.addEventListener('mouseleave', () => this.play());
          
          // Pause when tab hidden
          document.addEventListener('visibilitychange', () => {
            document.hidden ? this.pause() : this.play();
          });
          
          if (this.slides.length > 1) {
            this.play();
          }
        }

        play() {
          this.interval = setInterval(() => {
            this.next();
          }, this.autoplaySpeed);
        }

        pause() {
          clearInterval(this.interval);
        }

        next() {
          this.currentIndex = (this.currentIndex + 1) % this.slides.length;
          this.updateSlides();
        }

        updateSlides() {
          this.slides.forEach((slide, index) => {
            slide.setAttribute('aria-hidden', index !== this.currentIndex);
          });
        }
      }
    )
  }

  // offer gift wrapping
  (function giftWrapping() {
    const dataScript = document.querySelector('script[data-section-id="sqjig__gift__wrapping"]');
    if(dataScript === null) return;

    const settings = JSON.parse(dataScript.innerHTML);

    if(settings.enable_gift_wrapping) {
      const variantId = settings.variant_id;

      async function checkVariantExists(variantId) {
        try {
          const response = await fetch(`/variants/${variantId}.js`);
          
          if (response.ok) {
            const variant = await response.json();
            // console.log('Variant exists:', variant);
            return true;
          } else {
            // console.log('Variant does not exist');
            return false;
          }
        } catch (error) {
          console.error('Error checking variant:', error);
          return false;
        }
      }

      function createGiftWrapCheckboxHTML(label) {
        return `
          <div class="gift-wrap-option" style="padding: 15px; border-top: 1px solid #e5e5e5; margin-top: 15px;">
            <label style="display: flex; align-items: center; cursor: pointer;">
              <input type="checkbox" id="sqjig-gift-wrap-checkbox" style="margin-right: 10px;">
              <span>${label}</span>
            </label>
          </div>
        `;
      }

      function createGiftWrapModalHTML() {
        return `
          <div id="sqjig-gift-wrap-modal" style="
            display: none;
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
            z-index: 2147483639;
            align-items: center;
            justify-content: center;
          ">
            <div style="
              background: white;
              padding: 30px;
              border-radius: 8px;
              max-width: 400px;
              width: 90%;
              box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
            ">
              <h2 style="margin: 0 0 20px 0; font-size: 24px;">Gift Wrap Details</h2>
              
              <form id="sqjig-gift-wrap-form">
                <div style="margin-bottom: 15px;">
                  <label style="display: block; margin-bottom: 5px; font-weight: 500;">
                    Gift Sender Name
                  </label>
                  <input 
                    type="text" 
                    id="sqjig-gift-sender" 
                    required
                    style="
                      width: 100%;
                      padding: 10px;
                      border: 1px solid #ddd;
                      border-radius: 4px;
                      font-size: 14px;
                    "
                  >
                </div>

                <div style="margin-bottom: 20px;">
                  <label style="display: block; margin-bottom: 5px; font-weight: 500;">
                    Gift Receiver Name
                  </label>
                  <input 
                    type="text" 
                    id="sqjig-gift-receiver" 
                    required
                    style="
                      width: 100%;
                      padding: 10px;
                      border: 1px solid #ddd;
                      border-radius: 4px;
                      font-size: 14px;
                    "
                  >
                </div>

                <div style="margin-bottom: 20px;">
                  <label style="display: block; margin-bottom: 5px; font-weight: 500;">
                    Gift Message (Optional)
                  </label>
                  <textarea 
                    id="sqjig-gift-message"
                    rows="3"
                    style="
                      width: 100%;
                      padding: 10px;
                      border: 1px solid #ddd;
                      border-radius: 4px;
                      font-size: 14px;
                      resize: vertical;
                    "
                  ></textarea>
                </div>

                <div style="display: flex; gap: 10px;">
                  <button 
                    type="submit"
                    style="
                      flex: 1;
                      padding: 12px;
                      background: #000;
                      color: white;
                      border: none;
                      border-radius: 4px;
                      cursor: pointer;
                      font-size: 14px;
                      font-weight: 500;
                    "
                  >
                    Add Gift Wrap
                  </button>
                  <button 
                    type="button"
                    id="sqjig-cancel-gift-wrap"
                    style="
                      flex: 1;
                      padding: 12px;
                      background: #f0f0f0;
                      color: #333;
                      border: none;
                      border-radius: 4px;
                      cursor: pointer;
                      font-size: 14px;
                      font-weight: 500;
                    "
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        `;
      }

      class GiftWrapManager {
        constructor() {
          this.modal = null;
          this.checkbox = null;
          this.init();
        }

        init() {
          if (typeof window.Rebuy !== 'undefined') {
            this.setupEventListeners();
          } else {
            document.addEventListener('rebuy:cart.ready', () => {
              this.setupEventListeners();
            });
          }
        }

        setupEventListeners() {
          document.addEventListener('rebuy:smartcart.show', () => {
            this.injectCheckbox();
            this.disableGiftWrapControls();
          });

          document.addEventListener('rebuy:cart.change', () => {
            this.removeGiftWrapIfNoProducts();
            this.updateCheckboxState();
            this.disableGiftWrapControls();
          });
        }

        handleCheckboxChange(e) {
          if (e.target.checked) {
            this.showModal();
          } else {
            this.removeGiftWrap();
          }
        }

        updateCheckboxState() {
          if (!this.checkbox) return;

          const cart = window.Rebuy.Cart.getCart();
          const hasGiftWrap = cart.items.some(item => 
            item.variant_id === variantId
          );

          this.checkbox.checked = hasGiftWrap;
        }

        injectCheckbox() {
          if (document.getElementById('sqjig-gift-wrap-checkbox')) {
            return;
          }

          const cartContainer = document.querySelector('[data-rebuy-cart]') || document.querySelector('.rebuy-cart') || document.querySelector('#rebuy-cart');

          if (!cartContainer) {
            console.log('Rebuy cart container not found');
            return;
          }

          const checkboxHTML = createGiftWrapCheckboxHTML(settings.gift_wrapping_label || 'Add gift wrapping to my order');

          const checkoutButton = cartContainer.querySelector('[data-rebuy-checkout-button]') || cartContainer.querySelector('.rebuy-cart__checkout-button') || cartContainer.querySelector('button[name="checkout"]');

          if (checkoutButton) {
            checkoutButton.insertAdjacentHTML('beforebegin', checkboxHTML);
            
            this.checkbox = document.getElementById('sqjig-gift-wrap-checkbox');
            this.checkbox.addEventListener('change', (e) => this.handleCheckboxChange(e));
            
            this.updateCheckboxState();
          }
        }

        showModal() {
          if (!this.modal) {
            const modalHTML = createGiftWrapModalHTML();

            document.body.insertAdjacentHTML('beforeend', modalHTML);
            this.modal = document.getElementById('sqjig-gift-wrap-modal');

            // Setup event listeners
            document.getElementById('sqjig-gift-wrap-form').addEventListener('submit', (e) => {
              e.preventDefault();
              this.submitGiftWrap();
            });

            document.getElementById('sqjig-cancel-gift-wrap').addEventListener('click', () => {
              this.closeModal();
              if (this.checkbox) this.checkbox.checked = false;
            });

            this.modal.addEventListener('click', (e) => {
              if (e.target === this.modal) {
                this.closeModal();
                if (this.checkbox) this.checkbox.checked = false;
              }
            });
          }

          // Show modal
          this.modal.style.display = 'flex';
          document.body.style.overflow = 'hidden';
        }

        closeModal() {
          if (this.modal) {
            this.modal.style.display = 'none';
            document.body.style.overflow = '';
            
            document.getElementById('sqjig-gift-sender').value = '';
            document.getElementById('sqjig-gift-receiver').value = '';
            document.getElementById('sqjig-gift-message').value = '';
          }
        }

        async submitGiftWrap() {
          const sender = document.getElementById('sqjig-gift-sender').value;
          const receiver = document.getElementById('sqjig-gift-receiver').value;
          const message = document.getElementById('sqjig-gift-message').value;

          // Check if variant exists first
          const exists = await checkVariantExists(variantId);
          if (!exists) {
            alert('Gift wrapping product is currently unavailable.');
            this.closeModal();
            if (this.checkbox) this.checkbox.checked = false;
            return;
          }

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              items: [{
                id: variantId,
                quantity: 1,
                properties: {
                  'Gift Sender': sender,
                  'Gift Receiver': receiver,
                  ...(message.trim() && { 'Gift Message': message })
                }
              }]
            })
          })
          .then(response => response.json())
          .then(data => {
            console.log('Gift wrap added:', data);
            this.closeModal();
          })
          .catch(error => {
            console.error('Error adding gift wrap:', error);
          });
        }

        removeGiftWrap() {
          const cart = window.Rebuy.Cart.getCart();
          const giftWrapItem = cart.items.find(item => 
            item.variant_id === variantId
          );

          if (giftWrapItem) {
            window.Rebuy.Cart.removeItem(giftWrapItem);
          }
        }

        removeGiftWrapIfNoProducts() {
          const cart = window.Rebuy.Cart.getCart();
          const regularItems = cart.items.filter(item => item.variant_id !== variantId);
          
          if (regularItems.length === 0) {
            // No regular items, remove gift wrap
            this.removeGiftWrap();
            if (this.checkbox) {
              this.checkbox.checked = false;
            }
          }
        }

        disableGiftWrapControls(){
          const cartItems = document.querySelectorAll('.rebuy-cart__flyout-item');
          
          cartItems.forEach(item => {
            // Check if this is the gift wrap item by class name
            if (item.classList.contains('product-gift-wrapping')) {
              // Disable the quantity buttons
              const quantityWidget = item.querySelector('.rebuy-cart__flyout-item-quantity');
              if (quantityWidget) {
                quantityWidget.style.visibility = 'hidden';
              }
              
              // Disable all product links
              const productLinks = item.querySelectorAll('a[href*="/products/gift-wrapping"]');
              productLinks.forEach(link => {
                link.style.pointerEvents = 'none';
                link.style.cursor = 'default';
              });
            }
          });
        }

      }

      new GiftWrapManager();

    }

  })();

  // offer free customization
  (function freeCustomization() {
    const dataScript = document.querySelector('script[data-section-id="sqjig__free__customization"]');
    if(dataScript === null) return;

    const settings = JSON.parse(dataScript.innerHTML);

    if(settings.enable_free_customization) {
      
      function createFreeCustomizationButtonHTML() {
        return `
          <div class="free-customization-button-wrapper">
            <button 
              id="sqjig-free-customization-button"
              type="button"
              style="
                width: 100%;
                padding: 12px;
                background: #000;
                color: white;
                border: none;
                border-radius: 4px;
                cursor: pointer;
                font-size: 14px;
                font-weight: 500;
              "
            >
              ${settings.free_customization_label || 'Get Free Engraving'}
            </button>
          </div>
        `;
      }

      function createFreeCustomizationModalHTML() {
        return `
          <div id="sqjig-free-customization-modal" style="
            display: none;
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
            z-index: 2147483639;
            align-items: center;
            justify-content: center;
          ">
            <div style="
              background: white;
              padding: 30px;
              border-radius: 8px;
              max-width: 500px;
              width: 90%;
              box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
            ">
              <h2 style="margin: 0 0 20px 0; font-size: 24px;">Select Item for Free Customization</h2>
              
              <div id="sqjig-free-customization-items">
                <!-- Cart items will be loaded here -->
              </div>

              <div style="display: flex; gap: 10px; margin-top: 20px;">
                <button 
                  type="button"
                  id="sqjig-free-customization-close"
                  style="
                    flex: 1;
                    padding: 12px;
                    background: #f0f0f0;
                    color: #333;
                    border: none;
                    border-radius: 4px;
                    cursor: pointer;
                    font-size: 14px;
                    font-weight: 500;
                  "
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        `;
      }

      class FreeCustomizationManager {
        constructor() {
          this.modal = null;
          this.button = null;
          this.cartData = null;
          this.rebuyCart = null;
          this.init();
        }

        init() {
          if (typeof window.Rebuy !== 'undefined') {
            this.fetchAndStoreCart();
            this.setupEventListeners();
          } else {
            document.addEventListener('rebuy:cart.ready', () => {
              this.fetchAndStoreCart();
              this.setupEventListeners();
            });
          }
        }

        setupEventListeners() {
          document.addEventListener('rebuy:smartcart.show', () => {
            this.injectButton();
          });

          document.addEventListener('rebuy:cart.change', () => {
            this.fetchAndStoreCart();
            this.injectButton();
          });
        }

        injectButton() {
          if (document.getElementById('sqjig-free-customization-button')) {
            return;
          }

          const cartContainer = document.querySelector('[data-rebuy-cart]') || document.querySelector('.rebuy-cart') || document.querySelector('#rebuy-cart');

          if (!cartContainer) {
            console.log('Rebuy cart container not found');
            return;
          }

          const buttonHTML = createFreeCustomizationButtonHTML();

          const checkoutButton = cartContainer.querySelector('.rebuy-button.rebuy-cart__checkout-button');

          if (checkoutButton) {
            checkoutButton.insertAdjacentHTML('beforebegin', buttonHTML);
            
            this.button = document.getElementById('sqjig-free-customization-button');
            this.button.addEventListener('click', () => this.showModal());
          }
        }

        fetchAndStoreCart() {
          const rebuyCart = window.Rebuy.Cart;
          if (!rebuyCart) return;
          const cart = rebuyCart.getCart();
          this.cartData = cart.items;
          this.rebuyCart = rebuyCart.cart;
          // console.log('Cart stored:', this.cartData);
          this.checkCustomizationExists();
        }

        checkCustomizationExists() {
          this.hasCustomization = this.cartData.some(item => 
            item.properties && item.properties['_free_customization']
          );
          // console.log('Has customization:', this.hasCustomization);
        }

        getProductsWithCustomization() {
          const productsWithCustomization = new Set();
          
          this.cartData.forEach(item => {
            const hasTextEngraving = item.properties && item.properties['Text engraving'];
            const hasFreeCustomization = item.properties && item.properties['_free_customization'];
            
            if (hasTextEngraving || hasFreeCustomization) {
              productsWithCustomization.add(item.product_id);
            }
          });
          
          return productsWithCustomization;
        }

        addItemToCart(variantId, customizationText) {
          // Add selected item to cart with customization
          const safeText = String(customizationText || '').trim();

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              items: [{
                id: variantId,
                quantity: 1,
                properties: {
                  'Free Customization': safeText,
                  '_free_customization': 'true'
                }
              }]
            })
          })
          .then(response => response.json())
          .then(data => {
            console.log('Item added with customization:', data);
            this.closeModal();
          })
          .catch(error => {
            console.error('Error adding item:', error);
          });
        }

        updateItemToCart(lineKey, customizationText) {
          const keyStr = String(lineKey);

          const lineItem = this.cartData.find(item =>
            String(item.key) === keyStr || String(item.id) === keyStr || String(item.variant_id) === keyStr
          );

          if (!lineItem) {
            console.error('Line item not found. Current cart items:', this.cartData);
            return;
          }

          // Shopify expects the line item key (hash) for change.js; prefer the key and warn if missing
          const itemKey = lineItem.key || lineItem.id;
          if (!lineItem.key) {
            console.warn('Line item has no key; falling back to numeric id for change.js. Consider refreshing cart to obtain keys.');
          }

          const safeText = String(customizationText || '').trim();

          fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: itemKey,
              quantity: lineItem.quantity,
              properties: {
                ...(lineItem.properties || {}),
                'Free Customization': safeText,
                '_free_customization': 'true'
              }
            })
          })
          .then(response => response.json())
          .then(data => {
            console.log('Item updated with customization:', data);
            // Refresh stored cart so UI/logic stays in sync
            this.fetchAndStoreCart();
            this.closeModal();
          })
          .catch(error => {
            console.error('Error updating item:', error);
          });
        }

        // Escape text for safe insertion into HTML attributes and content
        escapeAttr(str) {
          return String(str || '')
            .replace(/&/g, '&amp;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
        }

        displayCartItems() {
          const itemsContainer = document.getElementById('sqjig-free-customization-items');
          itemsContainer.innerHTML = '';
          
          const productsWithCustomization = this.getProductsWithCustomization();
          
          // Create select dropdown with line items
          const selectHTML = `
            <select id="sqjig-free-customization-select" style="
              width: 100%;
              padding: 10px;
              border: 1px solid #ddd;
              border-radius: 4px;
              font-size: 14px;
              margin-bottom: 15px;
            ">
              <option value="">Select an item to customize</option>
              ${this.cartData.map((lineItem, index) => {
                const rebuyItems = (this.rebuyCart && this.rebuyCart.items) || [];
                const rbItem = rebuyItems.find(i =>
                  String(i.key) === String(lineItem.key) ||
                  String(i.id) === String(lineItem.id)
                );
                const productData = rbItem && rbItem.product;
                const hasTextEngraving = lineItem.properties && lineItem.properties['Text engraving'];
                const hasFreeCustomization = lineItem.properties && lineItem.properties['_free_customization'];
                const productHasCustomization = productsWithCustomization.has(lineItem.product_id);
                const hasCustomizationTag = productData && productData.tags && productData.tags.includes('po_tl');
                
                let isDisabled = hasTextEngraving || hasFreeCustomization || productHasCustomization || !hasCustomizationTag;
                const fullTitle = lineItem.title || '';

                let suffix = '';
                if (productHasCustomization) {
                  suffix = ' (Already customized)';
                } else if (!hasCustomizationTag) {
                  suffix = ' (Not customizable)';
                }

                const fullLabel = fullTitle + suffix;
                const disabledAttr = isDisabled ? 'disabled' : '';
                // Truncate only the product title (preserve suffix), provide full text in title tooltip
                const maxTitleLen = 60;
                const truncatedTitle = fullTitle.length > maxTitleLen ? fullTitle.slice(0, maxTitleLen - 3) + '...' : fullTitle;
                const displayLabel = truncatedTitle + suffix;
                const optionValue = lineItem.key || lineItem.id || lineItem.variant_id;
                return `<option title="${this.escapeAttr(fullLabel)}" value="${this.escapeAttr(optionValue)}" ${disabledAttr}>${this.escapeAttr(displayLabel)}</option>`;
              }).join('')}
            </select>

            <label style="display: block; margin-bottom: 5px; font-weight: 500;">
              Customization Text
            </label>
            <input 
              type="text" 
              id="sqjig-free-customization-text"
              placeholder="Enter your customization text"
              maxlength="75"
              style="
                width: 100%;
                padding: 10px;
                border: 1px solid #ddd;
                border-radius: 4px;
                font-size: 14px;
                margin-bottom: 15px;
              "
            >

            <button 
              id="sqjig-free-customization-submit"
              type="button"
              style="
                width: 100%;
                padding: 12px;
                background: #000;
                color: white;
                border: none;
                border-radius: 4px;
                cursor: pointer;
                font-size: 14px;
                font-weight: 500;
              "
            >
              Add Customization to Cart
            </button>
          `;
          
          itemsContainer.insertAdjacentHTML('beforeend', selectHTML);
        }

        showModal() {
          if (!this.modal) {
            const modalHTML = createFreeCustomizationModalHTML();
            document.body.insertAdjacentHTML('beforeend', modalHTML);
            this.modal = document.getElementById('sqjig-free-customization-modal');

            // Setup close button
            document.getElementById('sqjig-free-customization-close').addEventListener('click', () => {
              this.closeModal();
            });

            // Close on backdrop click
            this.modal.addEventListener('click', (e) => {
              if (e.target === this.modal) {
                this.closeModal();
              }
            })

            // the handler survives HTML replacements when `displayCartItems` re-renders.
            const itemsContainerNode = this.modal.querySelector('#sqjig-free-customization-items');
            if (itemsContainerNode && !this._freeCustomizationHandlerAttached) {
              itemsContainerNode.addEventListener('click', (e) => {
                const target = e.target;
                if (target && target.id === 'sqjig-free-customization-submit') {
                  const selectedNode = this.modal.querySelector('#sqjig-free-customization-select');
                  const textNode = this.modal.querySelector('#sqjig-free-customization-text');
                  const selectedLineKey = selectedNode ? selectedNode.value : '';
                  const customizationText = textNode ? textNode.value : '';

                  if (!selectedLineKey || !customizationText.trim()) {
                    alert('Please select an item');
                    return;
                  }

                  this.updateItemToCart(selectedLineKey, customizationText);
                }
              });
              this._freeCustomizationHandlerAttached = true;
            }
          }

          this.modal.style.display = 'flex';
          document.body.style.overflow = 'hidden';
          this.displayCartItems();
        }

        closeModal() {
          if (this.modal) {
            this.modal.style.display = 'none';
            document.body.style.overflow = '';
          }
        }

      }

      new FreeCustomizationManager();

    }

  })();

})();
